module.exports = __webpack_public_path__ + "img/charging-station.88b87d3a.svg";